'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _PlatMap = require('./PlatMap');

var _PlatMap2 = _interopRequireDefault(_PlatMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.defaultStyles = _PlatMap.defaultStyles;
exports.default = (0, _bdcoreData2.default)({
  community: true,
  lots: true,
  homes: true
}, {
  community: true
})(_PlatMap2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-platmap/build/index.js
// module id = 1277
// module chunks = 0